import { Component,  OnInit, Inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormValidation } from '../../../../classes/formValidation';
import { CalculateService } from '../../../../services/calculate.service';
import { SprinklerSettingFields } from '../../calculatorSettingsForm';
import { ISprinklerApplicationRateViewModel } from '../../interfaces';
import { INozzleDiameter } from './interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedUpdateService } from '../../../shared/dialogs/update.service';

@Component({
	moduleId: module.id,
	selector: 'sprinkler-application-rate',
	templateUrl: 'sprinkler-application-rate.html'
})

export class SprinklerApplicationRateComponent implements OnInit {

	public form: FormGroup;

	public nozzleDiameters: INozzleDiameter[] = [
		{ id: 1, value: 3 / 32, name: '3/32'},
		{ id: 2, value: 7 / 64, name: '7/64'},
		{ id: 3, value: 1 / 8, name: '1/8'},
		{ id: 4, value: 9 / 64, name: '9/64'},
		{ id: 5, value: 5 / 32, name: '5/32'}
	];

	public sprinklerTypes = [
		{ Id: 1, Name: 'Rainbird 20 JH'},
		{ Id: 2, Name: 'Weather Tec 10-20'}
	];

	public get f(): { [key in SprinklerSettingFields]: AbstractControl } {
		return this.form.controls as { [key in SprinklerSettingFields]: AbstractControl };
	}

	private _control: AbstractControl;
	private _initialValues: ISprinklerApplicationRateViewModel;

	constructor(
		private calculateService: CalculateService,
		@Inject(MAT_DIALOG_DATA) private _data: {
			form: FormGroup, control: AbstractControl },

		private _dialogRef: MatDialogRef<SprinklerApplicationRateComponent>,
		private _sharedUpdateService: SharedUpdateService,
	) {
	}

	ngOnInit(): void {
		this.form = this._data.form;
		this._control = this._data.control;
		this._initialValues = this.form.value; // save initial values
		this._setValidators();
	}

	public calculate(e: MouseEvent): void {
		let result: number;

		if (e) {
			e.stopPropagation();
		}

		result = this.calculateService.calculateSprinklerApplicationRate(
			this.f.Type.value,
			this.nozzleDiameters.find(x => x.id === this.f.NozzleDiameter.value).value,
			this.f.NozzlePressure.value,
			this.f.PipeSpacing.value,
			this.f.HeadSpacing.value
		);

		result = Number(result.toFixed(2));
		this._control.setValue(result);
		this._clearValidators();
		this._closeDialog();
	}

	public cancel(e: MouseEvent): void {
		this.form.reset(this._initialValues);
		this._clearValidators();
		this._closeDialog();
	}

	private _setValidators(): void {
		FormValidation.setValidator(this.f.HeadSpacing, [Validators.required]);
		FormValidation.setValidator(this.f.NozzleDiameter, [Validators.required]);
		FormValidation.setValidator(this.f.NozzlePressure, [Validators.required]);
		FormValidation.setValidator(this.f.PipeSpacing, [Validators.required]);
		FormValidation.setValidator(this.f.Type, [Validators.required]);
	}

	private _clearValidators(): void {
		FormValidation.clearValidator(this.f.HeadSpacing);
		FormValidation.clearValidator(this.f.NozzleDiameter);
		FormValidation.clearValidator(this.f.NozzlePressure);
		FormValidation.clearValidator(this.f.PipeSpacing);
		FormValidation.clearValidator(this.f.Type);
	}

	private _closeDialog() {
		this._sharedUpdateService.cancel();
		this._dialogRef.close();
	}
}
